import { Component } from '@angular/core';

@Component({
    selector: 'lui-drawer-bottom-container',
    template: ` <ng-content></ng-content>`,
    standalone: false
})
export class DrawerBottomContainerComponent {}
